import { Component, ViewChild, Output, EventEmitter, Input, OnChanges, ChangeDetectorRef } from "@angular/core"
import { FormControl } from "@angular/forms"
import { map, startWith } from "rxjs/operators"

@Component({
	selector: "app-comune-poi-autocomplete",
	templateUrl: "./comune-poi-autocomplete.component.html",
	styleUrls: ["./comune-poi-autocomplete.component.scss"]
})
export class ComunePoiAutocompleteComponent implements OnChanges {
	@Input() comuniList: any
	@Input() comuneLabel: string
	@Output() comuneSelected = new EventEmitter<any>()

	comuneControl = new FormControl()
	comuniOptions: any
	convertedComuniList: any

	constructor(private cdr: ChangeDetectorRef) {}

	ngOnChanges(changes) {
		this.comuneControl.setValue(this.comuneLabel || "")
		this.comuneLabel = changes.comuneLabel?.currentValue || ""

		if (changes && changes.comuniList) {
			this._initAutoComplete()
			this.cdr.detectChanges()
		}
	}

	emitComune(e) {
		const objValue = this.convertedComuniList.find(o => o[1] === e)
		this.comuneSelected.emit(objValue)
	}

	private _filter = (value: string | any, list) => {
		const isEntireObject = value instanceof Object || Array.isArray(value)
		return list.filter((option: any) => {
			return value
				? option[1]
						.toLowerCase()
						.includes(!isEntireObject ? value.toString().toLowerCase() : value[1].toString().toLowerCase())
				: true
		})
	}

	private _initAutoComplete() {
		if (this.comuniList) {
			this.convertedComuniList = Object.entries(this.comuniList)
			var arrCities = this.convertedComuniList.map(([id, city]) => ({ id, city }));

			arrCities.sort((a, b) => (a.city > b.city) ? 1 : ((b.city > a.city) ? -1 : 0));
		  
			this.convertedComuniList = arrCities.map(itemCity => [itemCity.id, itemCity.city]);
			this.comuniOptions = this.comuneControl.valueChanges.pipe(
				startWith(""),
				map(value => this._filter(value as string, this.convertedComuniList))
			)
		}
	}
}
